import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Wrapper } from '@pkg/components';
import { LabelledInput } from '@pkg/components/Sections/Admin';

import { type Competition, type GameCriteriaValues } from '@app/client';
import {
    DEFAULT_COMPETITION_CRITERIA_VALUES,
    handleInputValue,
    handleValueValidation,
    useFormErrors,
} from '@app/helpers';

export const requiredValuesFields = Object.keys(DEFAULT_COMPETITION_CRITERIA_VALUES);

interface GameValuesProps {
    onUpdate: (name: string, newValue: number) => void;
    gameData?: Competition;
}
export const GameValues = ({ onUpdate, gameData }: GameValuesProps) => {
    const { t } = useTranslation('admin_fantasy');
    const { formErrors, handleError } = useFormErrors({ fieldNames: requiredValuesFields });
    const initial = gameData
        ? (({ max_value, max_assets, max_player_count, max_user_submissions, min_collection_count }) => ({
              max_value,
              max_assets,
              max_player_count,
              max_user_submissions,
              min_collection_count,
          }))(gameData)
        : DEFAULT_COMPETITION_CRITERIA_VALUES;
    const [formData, setFormData] = useState<GameCriteriaValues>(initial);

    function handleInputValues(e) {
        const { name } = e.target;
        const value = handleInputValue(e);
        const error = handleValueValidation(e);
        handleError(name, error);
        if (name === 'min_collection_count') {
            //  TODO - consider helper for field reliant on others
            handleError(
                'max_assets',
                formData.max_assets < e.target.value ? `Value can't be less than minimum collection count` : '',
            );
        }

        setFormData((fd) => ({ ...fd, [name]: value }));
        onUpdate(name, Number(value));
    }
    return (
        <>
            {[
                <Wrapper padding="0 10px" key="max value" width="45%">
                    <LabelledInput
                        required
                        onChange={handleInputValues}
                        name="max_value"
                        id="max_value"
                        value={formData.max_value}
                        label={t('create_label_max_value')}
                        placeholder={t('create_placeholder_max_value')}
                        type="number"
                        min={1}
                        errorMessage={formErrors['max_value']}
                    />
                </Wrapper>,
                <Wrapper padding="0 10px" key="max players" width="45%">
                    <LabelledInput
                        required
                        onChange={handleInputValues}
                        name="max_player_count"
                        id="max_player_count"
                        value={formData.max_player_count}
                        label={t('create_label_max_player_count')}
                        placeholder={t('create_placeholder_max_player_count')}
                        type="number"
                        min={1}
                        errorMessage={formErrors['max_player_count']}
                    />
                </Wrapper>,
            ]}
        </>
    );
};
